import styled from 'styled-components';
import { Vehicle } from '../../../../types/vehicle';
import { formatCurrency } from '../../../../utils';

type Props = { vehicle: Vehicle };

const Wrapper = styled.div`
  display: flex;
  gap: 4px;
  width: 100%;
`;

const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 30px;
  flex: 1 1 100%;
  border-radius: 8px;
  background: rgba(203, 203, 203, 0.2);

  @media (orientation: landscape) {
    height: 44px;
  }
`;

const Value = styled.div`
  font-size: 12px;
  font-weight: 700;
  line-height: 14.06px;
  color: #000;
`;

const Label = styled.div`
  font-size: 8px;
  font-weight: 400;
  line-height: 9.38px;
  color: rgba(102, 102, 102, 1);
  @media (orientation: landscape) {
    text-align: center;
    padding: 0 12px;
  }
`;

export const MilesInfo = ({ vehicle }: Props) => {
  const items = [
    {
      value: vehicle.bluebook_value ? formatCurrency(vehicle.bluebook_value) : 'N/A',
      label: 'Value Without Miles Adj'
    },
    {
      value: vehicle.bluebook_mileage ? formatCurrency(vehicle.bluebook_mileage) : 'N/A',
      label: 'Blue Book@ Lending Value'
    },
    {
      value: vehicle.mileage ? formatCurrency(vehicle.mileage).slice(1) : 'N/A',
      label: 'Mileage'
    }
  ];

  return (
    <Wrapper>
      {items.map(item => (
        <ItemWrapper key={item.label}>
          <Value>{item.value}</Value>
          <Label>{item.label}</Label>
        </ItemWrapper>
      ))}
    </Wrapper>
  );
};
